import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { TransportActionBarComponent } from './component/transport-action-bar.component';
import { ActionsModule } from '../actions/actions.module';

@NgModule({
  declarations: [
    TransportActionBarComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    MatInputModule,
    MatTooltipModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ActionsModule
  ],
  exports: [
    TransportActionBarComponent
  ]
})
export class TransportActionBarModule { }
